<template>
	<div class="conversation-navbar navbar card">
		<div class="navbar-section solo-navbar-section">
			<button
				@click="closeConversationAndConversationInfo()"
				class="backbtn btn action link lg primary"
			>
				<icon>arrow-left</icon>
			</button>
			<div class="conversation-avatar-container">
				<ConversationAvatar
					v-if="avatarVisible"
					:providerName="getCurConversation.providerName"
					:conversationId="getCurConversation.id"
					class="flat rounded shadow lg"
					:key="
						getCurConversation.id
							? 'conversation_' +
							  getCurConversation.providerName +
							  '_' +
							  getCurConversation.id
							: 'conversation_' + getCurConversation.providerName
					"
				/>
				<!-- <button v-else class="conversation-avatar btn action flat rounded shadow lg"></button> -->
			</div>
			<div
				class="conversation-short-info input-group inline"
				:avatar-visible="avatarVisible"
			>
				<button
					class="conversation-name btn flat rounded"
					readonly="true"
					@click="openConversationInfo()"
				>
					{{ getCurConversation.name }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Icon from './Icon';
import ConversationAvatar from './ConversationAvatar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'ConversationNavbar',
	components: {
		Icon,
		ConversationAvatar
	},
	data() {
		return {};
	},
	computed: {
		avatarVisible() {
			return (
				this.getCurConversation.id &&
				this.conversationProviderHasAvatarProvider(
					this.getCurConversation.providerName
				)
			);
		},
		...mapGetters({
			getCurConversation: 'ConversationProviders/getCurConversation'
		})
	},
	methods: {
		conversationProviderHasAvatarProvider(providerName) {
			return this.$store.getters[
				'ConversationProviders/provider_' +
					providerName +
					'/getConversationAvatar'
			];
		},
		openConversationInfo() {
			this.$emit('update:conversationInfoOpen', true);
		},
		closeConversationInfo() {
			this.$emit('update:conversationInfoOpen', false);
		},
		closeConversationAndConversationInfo() {
			this.closeConversationInfo();
			this.closeConversation();
		},
		...mapActions(['closeConversation'])
	}
};
</script>
